import { BaseException } from "@/exceptions/base-exception.exception.ts"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights.ts"
import type { WorkPeriod } from "@/models/work-period.model.ts"

export class MultipleOngoingWorkPeriodsException extends BaseException {
  exceptionId = "MULTIPLE_ONGOING_WORK_PERIODS"
  title = "Lopende dienst"
  weight = ExceptionWeights.ERROR

  private readonly conflictingWorkPeriods: WorkPeriod[]

  constructor(conflictingWorkPeriods: WorkPeriod[]) {
    super()
    this.conflictingWorkPeriods = conflictingWorkPeriods
  }

  public getMessage(): string {
    const { conflictingWorkPeriods } = this

    if (conflictingWorkPeriods.length === 1) {
      const workPeriod = conflictingWorkPeriods[0]
      return `Er is al een dienst bezig op ${workPeriod.timeStart.format("DD MMMM")} vanaf ${workPeriod.timeStart?.format("HH:mm")} uur. Sluit deze eerst af.`
    }

    // More than one ongoing work period is not allowed, so we should not come here, but let us handle it anyway.
    return `Er zijn meerdere diensten bezig op ${conflictingWorkPeriods[0].timeStart.format("DD-MM")}:
          ${conflictingWorkPeriods
            .map((workPeriod) => {
              return `- ${workPeriod.timeStart?.format("HH:mm")} uur tot ${workPeriod.timeEnd?.format("HH:mm")} uur`
            })
            .join("\n")}`
  }
}
